import './index.scss'

import Sidebar from '../Sidebar';

const Contact = () => {
    return(
     <div className='App'>
        <Sidebar/>
     </div>
    )
}

export default Contact
